export function yearPicker(that, trs) {
  return [
    {
      h: "div",
      c: "year-picker",
      z: [
        {
          h: "div",
          c: "action-header",
          z: [
            {
              h: "div",
              c: "action-item-left",
              html: "«",
              event: (ev) => {
                that.selectFirst(ev);
              },
            },
            {
              h: "div",
              c: "action-item-content",
              html: `${that.list[1].year}-${
                that.list[that.list.length - 1].year
              }`,
            },
            {
              h: "div",
              c: "action-item-right",
              html: "»",
              event: (ev) => {
                that.selectLast(ev);
              },
            },
          ],
        },
        {
          h: "div",
          c: "action-mian",
          z: [
            {
              h: "table",
              c: "year-panel",
              z: [
                {
                  h: "tbody",
                  c: "",
                  z: trs,
                },
              ],
            },
          ],
        },
      ],
    },
  ];
}
